module.exports = __webpack_public_path__ + "img/Liberia.65a51b01.svg";